/**
 * JKL Footer
 *
 * - Newsletter: prevents the footer from showing the success state when another
 *   newsletter form (e.g. newsletter page) was submitted
 * - Newsletter consent validation lives in jkl-newsletter-consent.js (shared with the jkl-newsletter snippet)
 * - Links accordion: on click of .footer__links-title, toggles the .active class on sibling .footer__links-grid
 */

(function () {
  function initNewsletterSuccessSource(section) {
    const fieldsEl = section.querySelector(".footer-newsletter-fields");
    const successEl = section.querySelector(".newsletter-success-footer");
    const form = section.querySelector("#footer-newsletter");

    // If the success state is showing, check if the footer form was actually submitted
    if (successEl && successEl.style.display !== "none") {
      const source = sessionStorage.getItem("newsletter_submitted_from");
      if (source !== "footer") {
        // Not submitted from footer — show form fields, hide success
        if (fieldsEl) fieldsEl.style.display = "";
        successEl.style.display = "none";
      }
      sessionStorage.removeItem("newsletter_submitted_from");
    }

    // Mark footer as the source when its form is submitted
    if (form) {
      form.addEventListener("submit", function () {
        sessionStorage.setItem("newsletter_submitted_from", "footer");
      });
    }
  }

  function initFooterLinksToggle(footer) {
    footer.addEventListener("click", function (event) {
      const title = event.target.closest(".footer__links-title");
      if (!title) return;

      title.classList.toggle("active");

      const grid = title.nextElementSibling;
      if (grid && grid.classList.contains("footer__links-grid")) {
        grid.classList.toggle("active");
      }
    });
  }

  function initFooter(footer) {
    // Avoid binding listeners twice on the same footer element
    if (footer.dataset.footerInitialized) return;
    footer.dataset.footerInitialized = "true";

    const section = footer.closest(".shopify-section") || footer;

    initNewsletterSuccessSource(section);
    initFooterLinksToggle(footer);
  }

  function initAll() {
    document.querySelectorAll("[data-jkl-footer]").forEach(initFooter);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  // Re-initialize on Shopify theme editor section load/rerender
  document.addEventListener("shopify:section:load", function (event) {
    event.target.querySelectorAll("[data-jkl-footer]").forEach(initFooter);
  });
})();
